import { type PathArray, Polyline, type PolylineStyleProps } from '@antv/g6'

type ParsedPolylineStyleProps = Required<PolylineStyleProps>

export class LineagePolyline extends Polyline {
  protected getKeyPath(attributes: ParsedPolylineStyleProps): PathArray {
    const [sourcePoint, targetPoint] = this.getEndpoints(attributes)

    return [
      ['M', sourcePoint[0], sourcePoint[1]],
      ['L', targetPoint[0] / 2 + (1 / 2) * sourcePoint[0], sourcePoint[1]],
      ['L', targetPoint[0] / 2 + (1 / 2) * sourcePoint[0], targetPoint[1]],
      ['L', targetPoint[0], targetPoint[1]],
    ]
  }

  public animate(_keyframes: Keyframe[], _options) {
    const nodeData = this.context.graph.getNodeData(this.config.style.targetNode)
    const isRight = nodeData.position === 'right'
    const rightKeyframes: Keyframe[] = [{ lineDashOffset: 20 }, { lineDashOffset: 0 }]
    const leftKeyframes: Keyframe[] = [{ lineDashOffset: 0 }, { lineDashOffset: 20 }]

    const animation = super.animate(isRight ? rightKeyframes : leftKeyframes, {
      duration: 500,
      iterations: Infinity,
    })

    if (animation) {
      animation.onframe = () => this.onframe()
      animation.finished.then(() => this.onframe())
    }

    return animation
  }
}
